/* SOFT SKILLS NOTIFICATIONS */
export const GET_SOFTSKILLS_NOTIFICATIONS = "GET_SOFTSKILLS_NOTIFICATIONS"
export const GET_SOFTSKILLS_NOTIFICATIONS_SUCCESS =
  "GET_SOFTSKILLS_NOTIFICATIONS_SUCCESS"
export const GET_SOFTSKILLS_NOTIFICATIONS_ERROR =
  "GET_SOFTSKILLS_NOTIFICATIONS_ERROR"
